var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[(_vm.breadcrumbs)?_c('div',{staticClass:"title_breadcrumbs"},[_c('Breadcrumbs',{attrs:{"currentName":_vm.currentName,"type":_vm.type}})],1):_vm._e(),_vm._v(" "),_c('h1',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }